"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitTestResult = void 0;
/**
 * @public
 * An entity that user has interacted with.
 */
class HitTestResult {
    constructor(entity, 
    /**
     * The segments of the entity that passed the hit test.
     */
    segmentIds, 
    /**
     * The update arg.
     */
    hitTestArg, 
    /**
     * Additional filtering, typically the group mask.
     */
    filterMask) {
        this.entity = entity;
        this.segmentIds = segmentIds;
        this.hitTestArg = hitTestArg;
        this.filterMask = filterMask;
    }
}
exports.HitTestResult = HitTestResult;
//# sourceMappingURL=hit-test-result.js.map